import { SVGProps, Ref, forwardRef } from 'react';

export const PenHyperstarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M18.9 11.172 7.07 23H1v-6.071L12.828 5.1z" fill="currentColor" />
            <path d="M15.672 2.258a4.292 4.292 0 1 1 6.07 6.07L20.172 9.9 14.1 3.83z" fill="currentColor" />
            <path
                d="M4.5 1A13.3 13.3 0 0 0 8 4.5 13.3 13.3 0 0 0 4.5 8 13.3 13.3 0 0 0 1 4.5 13.3 13.3 0 0 0 4.5 1"
                fill="currentColor"
            />
        </g>
    </svg>
));
PenHyperstarFilledSize24Glyph.displayName = 'PenHyperstarFilledSize24Glyph';
